<div class="select-list-v2" [class.disabled]="disabled">
  <label *ngIf="label" [class.required]="required">{{ label }}</label>
  
  <div class="select-container" #selectContainer (click)="toggleDropdown($event)">
    <div class="select-value">
      <span *ngIf="selectedItem; else placeholderTpl">{{ selectedItem.label }}</span>
      <ng-template #placeholderTpl>
        <span class="placeholder">{{ placeholder }}</span>
      </ng-template>
    </div>
    <div class="select-arrow">
      <mat-icon>{{ isOpen ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}</mat-icon>
    </div>
  </div>
  
  <ng-template cdkPortal>
    <div class="dropdown-panel">
      <div class="items-list">
        <div class="item" 
             *ngFor="let item of items" 
             (click)="selectItem(item, $event)"
             [class.selected]="isSelected(item)">
          <div class="radio-button">
            <div class="radio-outer">
              <div class="radio-inner" *ngIf="isSelected(item)"></div>
            </div>
          </div>
          <div class="item-label">{{ item.label }}</div>
        </div>
      </div>
    </div>
  </ng-template>
  
  <div class="error-message" *ngIf="hasError && errorMessage">
    {{ errorMessage }}
  </div>
</div>
